<template>
  <checkbox
    :disabled="disabled"
    :label="label"
    :value="hasValue"
    :input-value="hasValue"
    @change="toggleDeleteCheckboxValue()"
  />
</template>
  
<script>
/**
 * @fileoverview Bulk delete checkbox
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";
import checkbox from "@/qux-common/qux22/components/molecules/checkbox";
import getFieldData from "@/util/getFieldData";
import defaultValueFromType from "@/util/defaultValueFromType";
import fieldMap from "@/components/config-field/field-map.json";

export default {
  name: "BulkDeleteCheckbox",
  components: { checkbox },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
    },
    label: {
      type: String,
    },
  },
  computed: {
    hasValue() {
      return !!this.fields.find(
        (field) =>
          typeof this.getConfigValue({
            id: field.id,
            category: field.category,
            parentField: field.parentField,
          }) !== "undefined"
      );
    },
    ...mapGetters({
      updatedValues: "getUpdatedConfigValues",
    }),
  },
  methods: {
    getConfigValue({ id, category, parentField }) {
      let configValue =
        this.updatedValues["bulkDelete"] &&
        this.updatedValues["bulkDelete"][category];

      if (parentField !== undefined) {
        configValue =
          configValue &&
          this.updatedValues["bulkDelete"][category][parentField] &&
          this.updatedValues["bulkDelete"][category][parentField][id];
      } else {
        configValue =
          configValue && this.updatedValues["bulkDelete"][category][id];
      }
      return configValue;
    },
    fieldList(category = this.category) {
      const fieldData = this.configTemplate && this.configTemplate[category];
      return fieldData && fieldData.AvailableFieldList;
    },
    getFieldValue({ value, id, category }) {
      let returnValue;
      if (value !== undefined && value.length > 0) {
        const fieldData = getFieldData(this.fieldList(category), id);
        if (fieldData) {
          let configKey = value.charAt(0).toUpperCase() + value.slice(1);
          returnValue = fieldData[configKey];
        }
      }
      if (returnValue === undefined) {
        returnValue =
          fieldMap[category] &&
          fieldMap[category][id] &&
          fieldMap[category][id][value];
      }
      return returnValue;
    },
    toggleDeleteCheckboxValue() {
      const hasValue = this.hasValue;
      for (const field of this.fields) {
        hasValue
          ? this.unsetCheckbox({
              id: field.id,
              parentField: field.parentField,
              category: field.category,
              type: field.type,
            })
          : this.setCheckbox({
              id: field.id,
              parentField: field.parentField,
              category: field.category,
              type: field.type,
            });
      }
    },
    setCheckbox({ category, id, parentField, type }) {
      const defaultValue =
        this.getFieldValue({ value: "defaultValue", category, id }) ||
        defaultValueFromType(type);

      let fieldId;
      let configValue = defaultValue;

      if (parentField !== undefined) {
        fieldId = parentField;
        configValue = { [id]: defaultValue };
      } else {
        fieldId = id;
      }

      this.$store.dispatch("setConfigValue", {
        ClientInfoRuleId: "bulkDelete",
        category,
        fieldId,
        value: configValue,
      });
    },
    unsetCheckbox({ category, id, parentField }) {
      this.$store.dispatch("unsetConfigValue", {
        ClientInfoRuleId: "bulkDelete",
        category,
        fieldId: id,
        parentField,
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
</style>